// Official Ma Petite Ferme full logo lockup (barn + wordmark).
export function Logo({ className = "h-12 w-auto" }) {
  return <img src="/logo.webp" alt="Ma Petite Ferme" width="601" height="200" className={`object-contain ${className}`} loading="eager" />;
}

// Wordmark is now part of the logo image; kept as a no-op for backward compatibility.
export function WordMark() {
  return null;
}
